// Filosofia.jsx
import React from 'react';
import {
  PageWrapper,
  HeroSection,
  ContentSection,
  TextBlock,
  StatementHeading,
  FullWidthImage,
  TwoColImages,
} from './PageTemplate';
import ProductBlock from '../../components/ProductBlock';
import SEO from '../../components/SEO';

const IMAGES = {
  fullWidth1: '/images/secciones/curated-selection/portada_sostenibilidad_physiology_skincare_cosmetic_mx.webp',
  fullWidth2: '/images/secciones/curated-selection/cream4.webp',
  // Imagen del final de la página (antes repetía fullWidth1, la del inicio).
  fullWidth3: '/images/secciones/curated-selection/Imagen_temporal_seccion_1.webp',
  grid: ['/images/secciones/curated-selection/Bha_serum_niacinamida_4_physiology_skincare_2.webp', '/images/secciones/curated-selection/Duo-anti-acne-physiology-skincare_portada.webp'],
};

const PRODUCTS = [
  {
    id: 'filo-prod1',
    title: 'Kit Minimalista',
    description: 'Este kit contiene todo lo que necesitas',
    price: 2430,
    originalPrice: 2700,
    image: 'https://pub-af8345b2339e47c4a9067290386af123.r2.dev/Kit_minimalista_physiology_skincare_2-01KXKVXS0Q41X4QTS8Q1RACA3V.webp',
    thumbnail: 'https://pub-af8345b2339e47c4a9067290386af123.r2.dev/Kit_minimalista_physiology_skincare_2-01KXKVXS0Q41X4QTS8Q1RACA3V.webp',
    handle: 'kit-minimalista',
    variants: [
      { id: 'v1-natural', title: 'Natural', label: 'Natural', price: 2430 },
      { id: 'v1-pigmento', title: 'Con pigmento', label: 'Con pigmento', price: 2430 },
    ],
    inStock: true,
    badge: 'basic',
  },
  {
    id: 'filo-prod2',
    title: 'Tx10/5 Azelaico + Niacinamide',
    description: 'Ayuda en manchas, rosácea y acné',
    price: 600,
    originalPrice: 700,
    image: 'https://pub-af8345b2339e47c4a9067290386af123.r2.dev/Niacinamida%204%2030%20ml%20n-01KVN2GE4Z5FWFYASXVYXKZCSH-01KWTVPDFDE8ZA6P5TF86NKX6X.webp',
    thumbnail: 'https://pub-af8345b2339e47c4a9067290386af123.r2.dev/Niacinamida%204%2030%20ml%20n-01KVN2GE4Z5FWFYASXVYXKZCSH-01KWTVPDFDE8ZA6P5TF86NKX6X.webp',
    handle: 'tx10-azelaico-niacinamide',
    variants: [{ id: 'v2', title: '40 ml', label: '40 ml', price: 600 }],
    inStock: true,
  },
];

const Filosofia = () => {
  return (
    <PageWrapper>
      <SEO
        title="Filosofía — Cuidado consciente, ciencia y ritual"
        description="La filosofía de Physiology Skincare Co: una mirada minimalista al cuidado facial que une ciencia, ingredientes limpios y rituales con intención."
        path="/filosofia"
      />

      {/* ── Hero ── */}
      <HeroSection
        category="Nuestra filosofía"
        title="Formular con criterio es el único lujo que vale la pena"
        meta="Principios que no negociamos"
      />

      {/* ── Imagen full-width ── */}
      <FullWidthImage src={IMAGES.fullWidth1} alt="Filosofía Physiology" />

      {/* ── Sección 1 ── */}
      <ContentSection narrow>
        <TextBlock
          heading="Menos ingredientes, mayor intención en cada uno"
          body="No creemos en las listas de 40 ingredientes que convierten un producto en un ejercicio de marketing. Cada componente de nuestras fórmulas tiene una función documentada, una concentración justificada y una razón para estar ahí. Lo que no suma, no entra."
        />
        <TextBlock
          heading="La concentración lo es todo"
          body="Un ingrediente activo a concentración sub-terapéutica es, en la práctica, decorativo. Formulamos en rangos clínicamente relevantes — los mismos que aparecen en la literatura científica que respalda cada activo. No ponemos niacinamida al 0.1% y la listamos como ingrediente protagonista."
        />
      </ContentSection>

      {/* ── Statement + texto ── */}
      <ContentSection narrow>
        <StatementHeading text="La piel no necesita más — necesita mejor:" />
        <TextBlock
          heading="Transparencia radical como estándar base"
          body="Publicamos las concentraciones de nuestros ingredientes activos. No porque la regulación lo exija — sino porque creemos que tienes derecho a saber exactamente qué estás aplicando. La opacidad en formulación es una señal de alerta que deberías conocer."
        />
        <TextBlock
          heading="Evidencia antes que tendencia"
          body="Cuando un ingrediente se vuelve viral en redes sociales, nuestro equipo no celebra — investiga. ¿Qué dice la literatura peer-reviewed? ¿En qué fototipos está documentado? ¿Tiene interacciones con activos que ya usamos? La pregunta nunca es si algo está de moda — la pregunta es si funciona."
        />
      </ContentSection>

      {/* ── Grid imágenes ── */}
      <ContentSection>
        <TwoColImages images={IMAGES.grid} />
      </ContentSection>

      {/* ── Más texto ── */}
      <ContentSection narrow>
        <TextBlock
          heading="Respeto por la barrera cutánea como principio irrenunciable"
          body="La piel tiene mecanismos de defensa sofisticados que la mayoría de los productos terminan comprometiendo en lugar de apoyar. Nuestro enfoque parte de no interrumpir lo que ya funciona — y de fortalecer lo que necesita apoyo. La barrera no es un obstáculo para los activos: es el sistema que hace posible que la piel esté sana."
        />
        <TextBlock
          heading="Formulación sin excusas de costo"
          body="Sabemos que usar ingredientes de alta pureza y en concentraciones efectivas tiene un costo mayor. Decidimos absorber ese costo en nuestros márgenes en lugar de trasladarlo a la fórmula. El precio al público refleja lo que vale — no lo que nos costaría hacer algo mediocre."
        />
      </ContentSection>

      {/* ── Imagen full-width ── */}
      <FullWidthImage src={IMAGES.fullWidth2} alt="Laboratorio de formulación" />

      {/* ── Texto final ── */}
      <ContentSection narrow>
        <TextBlock
          heading="No somos minimalistas por estética — lo somos por convicción"
          body="El minimalismo en nuestros productos no es una decisión de diseño de marca. Es la consecuencia lógica de formular con criterio: cuando cada ingrediente tiene que justificar su presencia, el resultado natural es una fórmula más corta y más poderosa."
        />
        <TextBlock
          heading="Una filosofía que se puede verificar"
          body="Todo lo que decimos sobre nuestros productos está documentado. Las concentraciones, los estudios que respaldan cada activo, los resultados en ensayos clínicos. No pedimos fe — ofrecemos evidencia. Esa es la diferencia entre una promesa de marketing y una promesa de formulación."
        />
      </ContentSection>

      {/* ── Productos ── */}
      <ProductBlock
        title="Productos relacionados"
        description="Formulados bajo nuestros principios"
        buttonText="Ver todos"
        products={PRODUCTS}
      />

      {/* ── Imagen cierre ── */}
      <FullWidthImage src={IMAGES.fullWidth3} alt="Physiology filosofía" />

      {/* ── Cierre ── */}
      <ContentSection narrow>
        <TextBlock
          heading="La filosofía no es un documento interno"
          body="Está en cada decisión de formulación, en cada etiqueta que imprimimos, en cada respuesta que damos cuando alguien nos pregunta por qué no incluimos cierto ingrediente. No es un manifesto — es un método."
        />
        <TextBlock
          heading="Y es la razón por la que seguimos aquí"
          body="En un mercado donde las marcas nacen y desaparecen cada temporada, mantenerse fiel a principios de formulación rigurosa no es lo más cómodo. Pero es lo único que tiene sentido si el objetivo real es la salud de la piel de las personas que confían en nosotros."
        />
      </ContentSection>

    </PageWrapper>
  );
};

export default Filosofia;
